import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToDestinations = () => {
    const element = document.getElementById('destinos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ad1e2851490287474d2680a6e3895caa.jpg"
          alt="Torres del Paine Chile"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
      </div>

      <div className="relative h-full flex flex-col items-center justify-center text-center px-4 md:px-8 w-full">
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold text-white mb-4 md:mb-6 tracking-tight drop-shadow-2xl">
          Discover Chile with <span className="whitespace-nowrap">GaLi Travel</span>
        </h1>
        <p className="text-xl sm:text-2xl md:text-3xl text-white/95 font-light italic mb-8 md:mb-12 drop-shadow-lg px-4">
          {t('hero_subtitle')}
        </p>
        <button
          onClick={scrollToDestinations}
          className="px-8 md:px-10 py-3 md:py-4 bg-gradient-to-r from-teal-500 to-cyan-600 text-white text-base md:text-lg font-semibold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          {t('hero_cta')}
        </button>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}